module.exports = __webpack_public_path__ + "img/Wizard.5adf6936.png";